<form [formGroup]="cableTypesForm">
  <div fxLayout="row" fxLayoutAlign="start center">
    <h4 fxFlex="33.33" i18n>Internal Cable</h4>
    <mat-form-field fxFlex="33.33" appearance="outline">
      <mat-label i18n>Underground</mat-label>
      <mat-select formControlName="internal_underground">
        <mat-option *ngFor="let value of CableTypeInternal" [value]="value">{{value}}</mat-option>
      </mat-select>
    </mat-form-field>

  </div>
  <div fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="start center">
    <h4 fxFlex i18n>Feeder Cable </h4>
    <mat-form-field fxFlex appearance="outline">
      <mat-label i18n>Underground</mat-label>
      <mat-select formControlName="feeding_underground">
        <mat-option *ngFor="let value of CableTypeUnderground" [value]="value">{{value}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field fxFlex appearance="outline">
      <mat-label i18n>Aerial</mat-label>
      <mat-select formControlName="feeding_aerial">
        <mat-option *ngFor="let value of CableTypeAerial" [value]="value">{{value}}</mat-option>
      </mat-select>
    </mat-form-field>

  </div>
  <div fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="start center">
    <h4 fxFlex i18n>Distribution Cable</h4>
    <mat-form-field fxFlex appearance="outline">
      <mat-label i18n>Underground</mat-label>
      <mat-select formControlName="distribution_underground">
        <mat-option *ngFor="let value of CableTypeUnderground" [value]="value">{{value}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field fxFlex appearance="outline">
      <mat-label i18n>Aerial</mat-label>
      <mat-select formControlName="distribution_aerial">
        <mat-option *ngFor="let value of CableTypeAerial" [value]="value">{{value}}</mat-option>
      </mat-select>
    </mat-form-field>

  </div>
  <div fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="start center">
    <h4 fxFlex i18n>Vertical Termination Cable</h4>
    <mat-form-field fxFlex appearance="outline">
      <mat-label i18n>Underground</mat-label>
      <mat-select formControlName="vertical_termination_underground">
        <mat-option *ngFor="let value of CableTypeUnderground" [value]="value">{{value}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field fxFlex appearance="outline">
      <mat-label i18n>Aerial</mat-label>
      <mat-select formControlName="vertical_termination_aerial">
        <mat-option *ngFor="let value of CableTypeAerial" [value]="value">{{value}}</mat-option>
      </mat-select>
    </mat-form-field>

  </div>
  <div *ngIf="showDropBusCables" fxLayout="row" fxLayoutAlign="start center">
    <h4 fxFlex i18n>Bus Drop Cable</h4>
    <mat-form-field fxFlex="33" appearance="outline">
      <mat-label i18n>Aerial</mat-label>
      <mat-select formControlName="drop_bus_aerial">
        <mat-option *ngFor="let value of CableTypeDropbus" [value]="value">{{value}}</mat-option>
      </mat-select>
    </mat-form-field>

  </div>
</form>

<mat-accordion>

  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title fxFlex="50" i18n>
        Internal Feeder Cable
      </mat-panel-title>
      <mat-panel-description>
        <span i18n>{internalFeedingCables.controls.length, plural, =0 {empty} =1 {1 cable} other
          {{{internalFeedingCables.controls.length}} cables}}</span>
        <mat-error *ngIf="internalFeedingCables.invalid">
          <mat-icon>error</mat-icon>
        </mat-error>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <form *ngFor="let formGroup of internalFeedingCables.controls; let index = index" [formGroup]="formGroup">
      <div fxLayout="row" fxLayoutGap="8px">
        <h4 fxFlex="25" i18n>Internal Feeder Cable {{index + 1 | number: '2.0-0'}}</h4>

        <mat-form-field fxFlex appearance="outline">
          <mat-label i18n>Fibers</mat-label>
          <mat-select formControlName="fibers">
            <mat-option *ngFor="let value of Fibers" [value]="value">{{value}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="params.central_office_settings.connector_dgo_internal_cable === 'connectorized_cable'" fxFlex appearance="outline">
          <mat-label i18n>Connector type</mat-label>
          <mat-select formControlName="connector_type">
            <mat-option *ngFor="let value of InternalCableConnector" [value]="value">{{value}}</mat-option>
          </mat-select>
        </mat-form-field>

        <div>
          <button mat-icon-button type="button" [disabled]="index === 0" (click)="removeInternalFeedingCable(index)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

      </div>
    </form>

    <mat-action-row>
      <button mat-stroked-button (click)="addInternalFeedingCable(getLastCableInternal())">
        <mat-icon>add</mat-icon>
        <span i18n>ADD</span>
      </button>
    </mat-action-row>

  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title fxFlex="50" i18n>
        Feeder Cable
      </mat-panel-title>
      <mat-panel-description>
        <span i18n>{feedingCables.controls.length, plural, =0 {empty} =1 {1 cable} other
          {{{feedingCables.controls.length}} cables}}</span>
        <mat-error *ngIf="feedingCables.invalid">
          <mat-icon>error</mat-icon>
        </mat-error>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <form *ngFor="let formGroup of feedingCables.controls; let index = index" [formGroup]="formGroup">
      <div fxLayout="row" fxLayoutGap="8px">
        <h4 fxFlex="25" i18n>Feeder Cable {{index + 1 | number: '2.0-0'}}</h4>

        <mat-form-field fxFlex appearance="outline">
          <mat-label i18n>Fibers</mat-label>
          <mat-select formControlName="fibers">
            <mat-option *ngFor="let value of Fibers" [value]="value">{{value}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex appearance="outline">
          <mat-label i18n>Reserve</mat-label>
          <input type="number" matInput formControlName="reserve">
        </mat-form-field>

        <div>
          <button mat-icon-button type="button" [disabled]="index === 0" (click)="removeFeedingCable(index)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

      </div>
      <ng-container *ngIf="!formGroup.errors?.fibersSmallerReserve else fibersErrorBlock"></ng-container>

    </form>

    <mat-action-row>
      <button mat-stroked-button (click)="addFeedingCable()">
        <mat-icon>add</mat-icon>
        <span i18n>ADD</span>
      </button>
    </mat-action-row>

  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title fxFlex="50" i18n>
        Distribution Cable
      </mat-panel-title>
      <mat-panel-description>
        <span i18n>{distributionCables.controls.length, plural, =0 {empty} =1 {1 cable} other
          {{{distributionCables.controls.length}} cables}}</span>
        <mat-error *ngIf="distributionCables.invalid">
          <mat-icon>error</mat-icon>
        </mat-error>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <form *ngFor="let formGroup of distributionCables.controls; let index = index" [formGroup]="formGroup">
      <div fxLayout="row" fxLayoutGap="8px">
        <h4 fxFlex="25" i18n>Distribution Cable {{index + 1 | number: '2.0-0'}}</h4>

        <mat-form-field fxFlex appearance="outline">
          <mat-label i18n>Fibers</mat-label>
          <mat-select formControlName="fibers">
            <mat-option *ngFor="let value of Fibers" [value]="value">{{value}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex appearance="outline">
          <mat-label i18n>Reserve</mat-label>
          <input type="number" matInput formControlName="reserve">
        </mat-form-field>

        <div>
          <button mat-icon-button type="button" (click)="removeDistributionCable(index)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

      </div>
      <ng-container *ngIf="!formGroup.errors?.fibersSmallerReserve else fibersErrorBlock"></ng-container>
    </form>

    <mat-action-row>
      <button mat-stroked-button (click)="addDistributionCable()">
        <mat-icon>add</mat-icon>
        <span i18n>ADD</span>
      </button>
    </mat-action-row>

  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title fxFlex="50" i18n>
        Vertical Building Attendance Cable
      </mat-panel-title>
      <mat-panel-description>
        <span i18n>{verticalAttendanceCables.controls.length, plural, =0 {empty} =1 {1 cable} other
          {{{verticalAttendanceCables.controls.length}} cables}}</span>
        <mat-error *ngIf="verticalAttendanceCables.invalid">
          <mat-icon>error</mat-icon>
        </mat-error>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <form *ngFor="let formGroup of verticalAttendanceCables.controls; let index = index" [formGroup]="formGroup">
      <div fxLayout="row" fxLayoutGap="8px">
        <h4 fxFlex="25" i18n>Vertical Building Attendance Cable {{index + 1 | number: '2.0-0'}}</h4>

        <mat-form-field fxFlex appearance="outline">
          <mat-label i18n>Fibers</mat-label>
          <mat-select formControlName="fibers">
            <mat-option *ngFor="let value of Fibers" [value]="value">{{value}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex appearance="outline">
          <mat-label i18n>Reserve</mat-label>
          <input type="number" matInput formControlName="reserve">
        </mat-form-field>

        <div>
          <button mat-icon-button type="button" (click)="removeVerticalAttendanceCable(index)" [disabled]="index === 0">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

      </div>
      <ng-container *ngIf="!formGroup.errors?.fibersSmallerReserve else fibersErrorBlock"></ng-container>
    </form>

    <mat-action-row>
      <button mat-stroked-button (click)="addVerticalAttendanceCable()">
        <mat-icon>add</mat-icon>
        <span i18n>ADD</span>
      </button>
    </mat-action-row>

  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="showDropBusCables">
    <mat-expansion-panel-header>
      <mat-panel-title fxFlex="50" i18n>
        1F Bus Drop Cable
      </mat-panel-title>
      <mat-panel-description>
        <span i18n>{dropBusCables.controls.length, plural, =0 {empty} =1 {1 cable} other
          {{{dropBusCables.controls.length}} cables}}</span>
        <mat-error *ngIf="dropBusCables.invalid">
          <mat-icon>error</mat-icon>
        </mat-error>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <form *ngFor="let formGroup of dropBusCables.controls; let index = index" [formGroup]="formGroup">
      <div fxLayout="row" fxLayoutGap="8px">
        <h4 fxFlex="25" i18n>1F Bus Drop Cable {{index + 1 | number: '2.0-0'}}</h4>

        <mat-form-field fxFlex appearance="outline">
          <mat-label i18n>Length</mat-label>
          <input type="number" matInput formControlName="length">
        </mat-form-field>

        <mat-form-field fxFlex appearance="outline">
          <mat-label i18n>Connector type</mat-label>
          <mat-select formControlName="connector_type">
            <mat-option *ngFor="let value of InternalCableConnector" [value]="value">{{value}}</mat-option>
          </mat-select>
        </mat-form-field>

        <div>
          <button mat-icon-button type="button" (click)="removeDropBusCable(index)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

      </div>
    </form>

    <mat-action-row>
      <button mat-stroked-button (click)="addDropBusCable(getLastCableDrop())">
        <mat-icon>add</mat-icon>
        <span i18n>ADD</span>
      </button>
    </mat-action-row>

  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title i18n>
        Max Cables Per Edge
      </mat-panel-title>
    </mat-expansion-panel-header>

    <form [formGroup]="form">
      <mat-form-field fxFlex="25" appearance="outline" class="app-block">
        <mat-label i18n>Max Cables Per Edge</mat-label>
        <input type="number" matInput formControlName="max_cables_per_edge">
      </mat-form-field>
    </form>
  </mat-expansion-panel>

</mat-accordion>

<ng-template #fibersErrorBlock>
  <div fxLayout="row">
    <mat-error fxFlex fxFlexOffset="50" i18n>Fibers must be greater than reserve</mat-error>
  </div>
</ng-template>
